module.exports = __webpack_public_path__ + "images/icons/flags/PE-44c7f2fa.svg";